<template>
  <div
    class="chat-page"
    :class="{
      'list-state': mobileState === mobileChatStates.LIST,
      'chat-state': mobileState === mobileChatStates.CHAT,
      'info-state': mobileState === mobileChatStates.INFO,
    }"
  >
    <ChatList class="chat-list-section"></ChatList>
    <ChatDialog class="chat-dialog-section"></ChatDialog>
  </div>
</template>

<script>
import ChatDialog from './components/ChatDialog/ChatDialog'
import ChatList from './components/ChatList/ChatList'
import { ChatMixin } from '../../mixins/chat'

export default {
  name: 'Chat',
  mixins: [ChatMixin],
  components: {
    ChatDialog,
    ChatList,
  },
}
</script>

<style src="./Chat.scss" lang="scss"></style>
